import { CSSelectOption, QuestionAnswerChoice, QuestionTranslation, TranslationAnswerChoice } from "types";

import { SupportedLocales } from "consts";

/**
 * Get available translation locale options.
 */
export const translationLocaleOptions: CSSelectOption[] = [
  { text: "Canadian English", value: SupportedLocales.EN_CA },
  { text: "Spanish", value: SupportedLocales.ES },
];

/**
 * Build question translation locale options
 * based on the available locales and the existing translations.
 */
export const buildTranslationLocaleOptions = (
  isUpdate: boolean,
  translations?: QuestionTranslation[],
): CSSelectOption[] => {
  const availableLocales: CSSelectOption[] = translationLocaleOptions;

  if (!translations || translations.length === 0) {
    return availableLocales;
  }

  const usedLocales = translations.map((t) => t.localeCode);
  return availableLocales.filter((locale) =>
    !isUpdate ? !usedLocales.includes(locale.value as string) : usedLocales.includes(locale.value as string),
  );
};

/**
 * Get question explanation text if available.
 */
export const getQuestionExplanationText = (questionAnswerChoices: QuestionAnswerChoice[]): string => {
  const choiceWithExplanation = questionAnswerChoices.find((choice) => choice.quizScore?.score === 1);
  return choiceWithExplanation?.quizScore?.explainText || "";
};

/**
 * Build default translation choices based on the answer choices.
 */
export const buildDefaultTranslationChoices = (answerChoices: QuestionAnswerChoice[]): TranslationAnswerChoice[] =>
  answerChoices.map(({ answerChoiceId }) => ({
    answerChoiceRefid: answerChoiceId,
    answerChoice: "",
    isQuizAnswer: false,
  }));

/**
 * Build translation default values.
 */
export const getCreateTranslationDefaults = (questionAnswerChoices: QuestionAnswerChoice[]): QuestionTranslation => {
  return {
    questionText: "",
    answerChoices: buildDefaultTranslationChoices(questionAnswerChoices),
    localeCode: SupportedLocales.ES,
    explanationText: "",
  };
};
